/** Navbar auth routes. */
export const NAV_COMPANY_LOGIN_PATH = "/login";
export const NAV_COMPANY_SIGNUP_PATH = "/signup";
export const NAV_FACILITATOR_SIGNUP_PATH = "/facilitator/signup";
